import { inspect } from 'util';
import Debug from '../../helpers/debug.js';
import ora from 'ora';
import axios from 'axios';
import Table from 'cli-table';
import descriptions from '../../helpers/descriptions.js';
import { pr, pp, cl, themed, printJSON } from '../../helpers/print.js';

const debug = Debug('commands:flows:list');

const command = 'list';

const desc = 'List flows';

const isNullOrEmptyArray = (value) => {
  if (value == null || (Array.isArray(value) && value.length === 0)) {
    // The variable is either null, undefined, or an empty array
    return true;
  }
  return false;
}

const builder = async (yargs) => {
  debug('builder', command);

  return yargs.option('tenant', { ...descriptions.options['tenant'].config });
};

const handler = async (argv) => {
  debug('handler', command, argv);

  const { hg, json, apikey, env, tenant } = argv;
  const { clientApiBaseUri } = hg;

  let message;
  let spinner = ora();
  try {
    // 1. get data from client-api backend
    message = themed(
      `Retrieving ${!tenant ? `the` : `${themed(tenant, 'info')} tenant's`} flows for environment: ${themed(
        env,
        'info'
      )}`
    );
    // todo: look into changing when if client-api combined these two endpoints
    const uri = `${clientApiBaseUri}/${env}/flows/${tenant ? `linked?user_id=${tenant}` : `supported`}`;
    debug('requesting:', uri);
    !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));
    const { data } = await axios.get(uri, { headers: { 'x-api-key': apikey } });
    !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));
    debug('response-data', data);

    // exit if there is no data
    if (!data || data.length === 0) {
      json
        ? printJSON([])
        : spinner.warn(themed(`Warning: ${themed('No flows for specified environment and tenant')}.`, 'secondary'));
      return;
    }

    if (json) {
      printJSON(data);
    } else {
      // generate results table
      const table = new Table({
        head: ['ID', 'Name', 'Flow Type', 'Taps', 'Targets', 'Connectors'],
      });

      data.sort((a, b) => (a.name || '').localeCompare(b.name || ''));

      data.forEach((item) =>
        table.push([
          item.id,
          item.name || '',
          (item.version == 2 ? 'Bidirectional' : (item.type ? 'Target Flow' : 'Source Flow')),
          (!isNullOrEmptyArray(item.taps) ? item.taps : (item.sources ? item.sources : [])).join('\n'),
          (item.targets ? item.targets : []).join('\n'),
          (item.connectors ? item.connectors : []).join('\n'),
        ])
      );
      // print results
      console.log(table.toString());
    }
  } catch (err) {
    if (json) {
      printJSON({ status: 'error', error: err });
    } else {
      spinner.fail(themed(`Error: ${message}.`, 'secondary'));
      pr(themed(`Message: ${themed(err.message)}`, 'secondary'));
      debug(err);
      if (err && err.response && err.response.data) {
        debug('response', err.response.data);
      }
    }
    process.exit(1);
  }
};

export { command, desc, builder, handler };
